// validation.js
import { fetchZipCode } from '../../../../app/api/zipCodeApi';
import { PREFECTURE_NAME_TO_ID } from './constant';
import { ZIPCODE_LENGTH } from '../../../../constants/progressBanner';

export const validateZipCode = async zipCode => {
    if (zipCode.length < ZIPCODE_LENGTH.MIN) {
        return {
            isValid: false,
            error: '',
            data: null,
        };
    }

    if (zipCode.length >= ZIPCODE_LENGTH.MAX) {
        return {
            isValid: false,
            error: '無効な郵便番号です。',
            data: null,
        };
    }

    const response = await fetchZipCode(zipCode);

    if (!response.results) {
        return {
            isValid: false,
            error: '該当する住所が見つかりませんでした。',
            data: null,
        };
    }

    const prefName = response.results[0].address1;
    const cityName = response.results[0].address2;
    const prefId = PREFECTURE_NAME_TO_ID[prefName];
    const address = `${response.results[0].address1}${response.results[0].address2}`;

    return {
        isValid: true,
        error: '',
        data: {
            prefectureId: prefId,
            cityName,
            address,
        },
    };
};
